export default "__VITE_ASSET__cd0babca__"